import { DirectionalDroppableType, Widget } from '@framework/engine';
import React from 'react';
import styled from 'styled-components';
import { ContainerExtraDroppable } from './ContainerExtraDroppable';

const ContainerDroppableAreasWrapper = styled.div`
  position: relative;
`;
const ContainerDroppableAreasReset = styled.div``;

export interface ContainerDroppableAreasProps {
  widget: Widget;
  parent?: Widget;
  // isSpaceForDrag?: boolean;
  // isDragOverlay?: boolean;
  // l'utente sta spostano un widget (dragging)
  isMoving?: boolean;

  children?: React.ReactNode;
}

/**
 * Aggiunge due aree Drop sopra e sotto l'elemento Container.
 */
export function ContainerDroppableAreas(props: ContainerDroppableAreasProps) {
  const { widget, parent } = props;

  return (
    <ContainerDroppableAreasWrapper>
      <ContainerExtraDroppable
        widget={widget}
        parent={parent}
        type={DirectionalDroppableType.Before}
      />
      <ContainerDroppableAreasReset>
        {props.children}
      </ContainerDroppableAreasReset>
      <ContainerExtraDroppable
        widget={widget}
        parent={parent}
        type={DirectionalDroppableType.After}
      />
    </ContainerDroppableAreasWrapper>
  );
}
